// @flow

import React from 'react';
import styled from 'styled-components';

import Data from 'data/global/footer/social';
import { Link } from 'components/Gui';
import { Color, hoverChild, Width } from 'styles';

const Wrapper = styled.div`
  display: flex;

  @media print, screen and (min-width: ${Width.BREAK_MD}px) {
    order: 1;
  }

  a {
    margin-right: 24px;

    svg {
      width: 3.2rem;
      ${hoverChild('path', 'fill', Color.WHITE, Color.MARKETS_RED)};
    }
  }
`;

const Social = () => (
  <Wrapper>
    {Data.map(({ svg, url, label }, index) => (
      <Link url={url} label={label} key={`SocialIcon-${index}`}>
        {svg}
      </Link>
    ))}
  </Wrapper>
);

export default Social;
